/** Maps Bronte viewer env to LT runtime env */
export function mapBronteEnvToLtEnv(env: string | undefined): string {
  switch (env) {
    case "qaint":
      return "qa";
    case "prod":
      return "prd";
    default:
      return env ?? "stg";
  }
}
